module.exports = __webpack_public_path__ + "img/20190612_132334_017.22d41cde.jpg";